import { Shirt, Briefcase, Palette } from "lucide-react";

export default function Branding() {
  return (
      <section style={styles.container}>
        <h1 style={styles.heading}>Branding Services</h1>
        <p style={styles.subheading}>
          Refined branding solutions designed to elevate your identity
        </p>

        <div style={styles.cards}>
          {branding.map((item) => (
              <div key={item.title} style={styles.card}>
                <div style={styles.icon}>{item.icon}</div>
                <h3 style={styles.cardTitle}>{item.title}</h3>
                <p style={styles.cardText}>{item.description}</p>
              </div>
          ))}
        </div>
      </section>
  );
}

const branding = [
  {
    title: "Custom Apparel",
    description: "High-quality t-shirt and merchandise printing",
    icon: <Shirt size={22} />
  },
  {
    title: "Corporate Branding",
    description: "Professional branded clothing & materials",
    icon: <Briefcase size={22} />
  },
  {
    title: "Event Merchandise",
    description: "Branded items crafted for special occasions",
    icon: <Palette size={22} />
  }
];

const styles = {
  container: {
    padding: "100px 40px",
    backgroundColor: "#faf9f6",
    textAlign: "center",
    minHeight: "100vh"
  },

  heading: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "34px",
    fontWeight: "400",
    color: "#111",
    marginBottom: "10px"
  },

  subheading: {
    fontSize: "15px",
    color: "#777",
    marginBottom: "70px"
  },

  cards: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: "26px",
    maxWidth: "900px",
    margin: "0 auto"
  },

  card: {
    backgroundColor: "#ffffff",
    borderRadius: "18px",
    padding: "40px 30px",
    border: "1px solid rgba(200,180,170,0.35)",
    boxShadow: "0 12px 30px rgba(0,0,0,0.05)"
  },

  icon: {
    color: "#c9b6ab",
    marginBottom: "16px"
  },

  cardTitle: {
    fontSize: "18px",
    fontWeight: "500",
    color: "#111",
    marginBottom: "8px"
  },

  cardText: {
    fontSize: "14px",
    color: "#666",
    lineHeight: "1.6"
  }
};
